module.exports = __webpack_public_path__ + "media/images/index/area/faeture_kyushu-a10f4994f960c830e8da0324d6ba4913.png";